import { searchApi } from '@shared/api/server'
import { PaginatedResponse } from '@shared/lib/pagination/pagination'
import { persistStorage } from '@shared/lib/persist-storage'

import { ADDRESS_LIST_LENGTH, CITY_LIST_LENGTH } from '../config'
import { AddressListDTO, CityListDTO } from '../types'
import { AddressModel, AddressModelJson } from './address.model'

export interface IAddressRepository {
  getCityList(dto: CityListDTO): Promise<PaginatedResponse<AddressModel[]>>
  getAddressList(
    dto: AddressListDTO
  ): Promise<PaginatedResponse<AddressModel[]>>
  saveCity(city: AddressModel): void
  getCity(): AddressModel | null
}

export class AddressRepository implements IAddressRepository {
  async getCityList({
    cityPart,
    page,
    size = CITY_LIST_LENGTH
  }: CityListDTO): Promise<PaginatedResponse<AddressModel[]>> {
    const response = await searchApi.getAddressesForAutocompleteCall({
      page: page,
      cityPart: cityPart,
      addressPart: '',
      pageSize: size
    })
    if (!response || response.total === 0) {
      return new PaginatedResponse<AddressModel[]>([], {
        page: 1,
        size: CITY_LIST_LENGTH,
        total: 0
      })
    }
    const list = response.items.map(
      (item) =>
        new AddressModel(
          item.latitude,
          item.longitude,
          item.addressEn ?? null,
          item.country,
          '',
          item.docCount
        )
    )
    return new PaginatedResponse<AddressModel[]>(list, {
      page: response.page,
      size: response.size,
      total: response.total
    })
  }

  async getAddressList({
    addressPart,
    city,
    page,
    size = ADDRESS_LIST_LENGTH
  }: AddressListDTO): Promise<PaginatedResponse<AddressModel[]>> {
    const response = await searchApi.getAddressesForAutocompleteCall({
      page: page,
      cityPart: city,
      addressPart: addressPart,
      pageSize: ADDRESS_LIST_LENGTH
    })
    if (!response || response.total === 0) {
      return new PaginatedResponse<AddressModel[]>([], {
        page: 1,
        size,
        total: 0
      })
    }
    const list = response.items.map(
      (item) =>
        new AddressModel(
          item.latitude,
          item.longitude,
          city,
          item.country,
          item.addressEn,
          item.docCount
        )
    )
    return new PaginatedResponse<AddressModel[]>(list, {
      page: response.page,
      size: response.size,
      total: response.total
    })
  }

  saveCity(city: AddressModel): void {
    return persistStorage.setItemSafe('cc', city.getJson())
  }
  getCity(): AddressModel | null {
    const savedCity = persistStorage.getItem<AddressModelJson>('cc')
    if (!savedCity) {
      return null
    }
    return new AddressModel(
      savedCity.latitude,
      savedCity.longitude,
      savedCity.city,
      savedCity.country,
      savedCity.addressEn,
      savedCity.userCount
    )
  }
}
